import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  SFDatagrid,
  SFPageContainer,
  SFActionBar,
  ACTION_BAR_ACTION_NAMES,
  ACTION_BAR_ACTION_TYPES,
} from "@sf-core";
import { PATHS } from "../../constants/paths";
import getNavDefs from "../navDefs/getSkillsExtractionNavDefs";
import { useSelector } from "react-redux";
import { API_PARAM } from "../../constants/apiParams";
import { GridNames } from "../../constants/gridConfig";
import {
  exportSecondaryTextGrid,
  uploadFromSecondaryText,
} from "../../services/secondaryTextService";
import { Claims } from "../../constants/claims";

const SecondaryText = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const navDefs = getNavDefs({ t });

  const secondaryTextGridLayout = useSelector((state) =>
    state.gridLayout.find((grid) => grid.gridName === GridNames.SECONDARY_TEXT)
  );

  const handleSecondaryTextDownload = () => {
    exportSecondaryTextGrid(secondaryTextGridLayout?.filterModel ?? {});
  };

  const columnDefs = useMemo(
    () => [
      {
        headerName: t(
          "secondaryTextScreen.secondaryTextGrid.microSkillIdColumn"
        ),
        field: "microSkillId",
        hide: false,
      },
      {
        headerName: t(
          "secondaryTextScreen.secondaryTextGrid.microSkillNameColumn"
        ),
        field: "microSkillName",
        filter: true,
        filterParams: {
          order: 1,
        },
      },
      {
        headerName: t(
          "secondaryTextScreen.secondaryTextGrid.secondaryTextColumn"
        ),
        field: "secondaryText",
        filter: true,
        filterParams: {
          order: 2,
        },
      },
    ],
    []
  );

  const actionDefs = [
    {
      name: ACTION_BAR_ACTION_NAMES.ADD,
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      permissions: [Claims.AdminDataSkillExtractionImport],
      onClick: () => navigate(PATHS.SECONDARY_TEXT_PATH_ADD),
      buttonProps: {
        label: t("manageSkillsExtractionScreen.addSecondaryTextBtn"),
        variant: "primary",
      },
    },
    {
      name: ACTION_BAR_ACTION_NAMES.DOWNLOAD,
      type: ACTION_BAR_ACTION_TYPES.ICON,
      permissions: [Claims.AdminDataSkillExtractionExport],
      onClick: handleSecondaryTextDownload,
      iconProps: {
        tooltip: t("analyticsSkillExtractionRoutes.download.secondaryText"),
        overflowLabel: t(
          "analyticsSkillExtractionRoutes.download.secondaryText"
        ),
      },
    },
    {
      name: "submitSecondaryText",
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      permissions: [Claims.AdminDataSkillExtractionUpload],
      onClick: uploadFromSecondaryText,
      buttonProps: {
        label: t("analyticsSkillExtractionRoutes.submitButtonLabel"),
        variant: "primary",
        async: true,
      },
      confirmation: true,
      confirmationProps: {
        message: t("benchmark.submitDictionaryButton.submitMessage"),
        header: t("benchmark.submitDictionaryButton.submitHeader"),
        primaryLabel: t("benchmark.submitDictionaryButton.submitConfirm"),
        secondaryLabel: t("benchmark.submitDictionaryButton.submitCancel"),
      },
    },
    {
      name: ACTION_BAR_ACTION_NAMES.FILTER,
      type: ACTION_BAR_ACTION_TYPES.ICON,
      filterParams: {
        gridName: GridNames.SECONDARY_TEXT,
      },
    },
  ];

  return (
    <>
      <SFPageContainer disableGutters>
        <SFActionBar
          titleProps={{
            title: t("analyticsSkillExtractionRoutes.secondaryText"),
          }}
          actionDefs={actionDefs}
          navDefs={navDefs}
        />
        <SFDatagrid
          fitScreen
          canDownload={false}
          columnDefs={columnDefs}
          gridName={GridNames.SECONDARY_TEXT}
          datasourceUrl={API_PARAM.SECONDARY_TEXT_GRID}
          filterValuesUrl={API_PARAM.SECONDARY_TEXT_COL_FILTER}
          basicFiltering
        />
      </SFPageContainer>
    </>
  );
};

export default SecondaryText;
